import React from 'react'

const EditAllMoviesListCheck = ({check}) => (
    <div className='check-item'>
        <div className={check ? 'has-content check-indicator' : 'has-no-content check-indicator'}></div>
    </div>
)

export default EditAllMoviesListCheck
